<template>
    <AccountViewBase :account="account" :loading="loading" :error="error">
        <CompaniesManager :mode="mode" :customProspectOptions="customProspectOptions" />
    </AccountViewBase>
</template>

<script>
    import { mapState } from 'pinia';
    import AccountViewBase from '@/views/account/AccountViewBase';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import accountMixin from '@/mixins/accountMixin';
    import CompaniesManager from '@/components/account/companies/CompaniesManager';
    import { useCompaniesStore } from '@/stores/companies';

    export default {
        name: 'CompaniesView',
        components: {
            AccountViewBase,
            CompaniesManager
        },
        mixins: [i18nViewMixin, accountMixin],
        props: {
            mode: {
                type: String,
                required: false
            },
            prospectOptions: {
                type: String,
                required: false,
                default: null
            }
        },
        data() {
            return {
                seo_title: 'views.companies.seo_title',
                customProspectOptions: null
            };
        },
        computed: {
            ...mapState(useCompaniesStore, {
                companiesMode: 'mode'
            })
        },
        methods: {
            generateSeoTitle() {
                switch (this.companiesMode) {
                    case 'new':
                        this.seo_title = 'views.suspects.seo_title';
                        break;
                    case 'prospects':
                        this.seo_title = 'views.prospects.seo_title';
                        break;
                    default:
                        this.seo_title = 'views.companies.seo_title';
                        break;
                }
                this.updateDocumentTitle();
            },
            parseProspectOptions() {
                if (this.prospectOptions) {
                    try {
                        this.customProspectOptions = JSON.parse(this.prospectOptions);
                        const query = { ...this.$route.query };
                        delete query.prospectOptions;
                        
                        this.$router.replace({
                            path: this.$route.path,
                            query: Object.keys(query).length ? query : undefined
                        });
                    } catch {
                        this.customProspectOptions = null;
                    }
                } else {
                    this.customProspectOptions = null;
                }
            }
        },
        watch: {
            companiesMode: 'generateSeoTitle',
            prospectOptions: {
                handler: 'parseProspectOptions',
                immediate: true
            }
        }
    }
</script>